"use client";

import { ROUTES } from "@/@core/constants/routes";
import { usePathname, useSearchParams } from "next/navigation";

export default function CanonicalTag({ domain }: { domain: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const formattedDomain = domain.startsWith("www.") ? domain : "www." + domain;

  let fullUrl = formattedDomain + pathname;

  if (pathname.includes(ROUTES.BLOG)) {
    const queryString = searchParams.toString();
    const fullQuery = queryString ? `?${queryString}` : "";

    fullUrl += fullQuery;
  }

  return <link rel="canonical" href={"https://" + fullUrl} />;
}
